
export const answerKey = (identifier: string, rowId: string) => {
  if (!rowId)
    rowId = '';
    
  return `${identifier}-${rowId}`;
}